import { MeetingsSchedule } from "@api/models/meetings-schedule/MeetingsSchedule";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";
import { UserProfile } from "@api/models/UserProfile";
import { DateItemInterface } from "@share/date-switcher/DateItemInterface";
import { DateTime } from "luxon";
import Vue from "vue";

export interface MScheduleDataStorageInterface {
    profiles: Map<number, UserProfile>;
    slots: Record<string, MScheduleSlot[]>;
    schedules: Record<string, MeetingsSchedule[]>;
    rootSchedules: MeetingsSchedule[];
    dates: DateItemInterface[];

    /**
     * Задание родительских расписаний
     * @param schedules
     */
    setRootSchedules(schedules: MeetingsSchedule[]): void;

    /**
     * Задание расписаний
     * @param payload
     * @param parentScheduleId
     */
    setSchedules(payload: MeetingsSchedule[], parentScheduleId: string): void;
    getScheduleById(scheduleId: string): MeetingsSchedule | undefined;

    setSlots(payload: Record<string, MScheduleSlot[]>): void;
    updateSlot(payload: MScheduleSlot): void;
    deleteSlot(slotId: string): string | undefined;

    setUserProfiles(payload: Map<number, UserProfile>): void;
    addUserProfile(payload: UserProfile): void;

    deleteSchedule(scheduleId: string): void;
    deleteConcreteSchedule(parentId: string, scheduleId: string): void;
}

export class MScheduleDataStorage implements MScheduleDataStorageInterface {
    profiles: Map<number, UserProfile> = new Map();
    slots: Record<string, MScheduleSlot[]> = {};
    schedules: Record<string, MeetingsSchedule[]> = {};
    rootSchedules: MeetingsSchedule[] = [];
    dates: DateItemInterface[] = [];

    setCustomDates(customDates: DateItemInterface[]) {
        this.dates = customDates;
    }

    setRootSchedules(schedules: MeetingsSchedule[]) {
        this.rootSchedules = schedules;
    }

    setSchedules(payload: MeetingsSchedule[], parentScheduleId: string): void {
        Vue.set(this.schedules, parentScheduleId, payload);
    }

    getScheduleById(scheduleId: string): MeetingsSchedule | undefined {
        let result;
        //OWN METHOD
        for (const rootId in this.schedules) {
            if (Object.prototype.hasOwnProperty.call(this.schedules, rootId) && !result) {
                result = this.schedules[rootId].find((schedule) => schedule.id === scheduleId);
            }
        }

        return result;
    }

    deleteSchedule(scheduleId: string) {
        //ищем для удаления сначала родительские элементы
        const rootForDelete = this.rootSchedules.find((schedule) => schedule.id === scheduleId);

        if (rootForDelete) {
            //удаляем слоты дочерних расписаний ☠️
            const childrenSchedulesIds = this.schedules[scheduleId]?.map((childSchedule) => childSchedule.id);

            if (childrenSchedulesIds && childrenSchedulesIds.length) {
                this.deleteSlots(childrenSchedulesIds);
            }

            //удаляем дочерние расписания ☠️
            delete this.schedules[scheduleId];
            this.rootSchedules = this.rootSchedules.filter((schedule) => schedule.id !== scheduleId);
        }
        else {
            //если удаление не родительского элемента то ищем среди дочерних
            let forDelete;

            //ONW METHOD
            for (const rootId in this.schedules) {
                if (Object.prototype.hasOwnProperty.call(this.schedules, rootId) && !forDelete) {
                    forDelete = this.schedules[rootId].find((schedule) => schedule.id === scheduleId);
                }
            }

            if (forDelete) {
                this.deleteConcreteSchedule(forDelete.parentId, forDelete.id);
            }
        }
    }

    deleteConcreteSchedule(parentId: string | undefined, scheduleId: string) {
        if (parentId) {
            const index = this.schedules[parentId].findIndex((schedule) => schedule.id === scheduleId);
            Vue.delete(this.schedules[parentId], index);
            Vue.delete(this.slots, scheduleId);
        }
    }

    setSlots(payload: Record<string, MScheduleSlot[]>): void {
        this.slots = { ...this.slots, ...payload };
    }

    updateSlot(payload: MScheduleSlot) {
        this.slots[payload.scheduleId]?.forEach((slot, index) => {
            if((slot.beginAt as DateTime).toISO() === (payload.beginAt as DateTime).toISO()) {
                Vue.set(this.slots[payload.scheduleId], index, payload)
            }
        })
    }

    deleteSlot(slotId: string) {

        let slotScheduleId: string | undefined;
        let slotIndex: number | undefined;

        for (const scheduleId in this.slots) {
            //обход по ключам - в качестве ключей scheduleId
            if (Object.prototype.hasOwnProperty.call(this.slots, scheduleId) && !slotScheduleId) {
                const index = this.slots[scheduleId].findIndex((slot) => slot.id === slotId);

                if (index >= 0) {
                    slotScheduleId = scheduleId
                    slotIndex = index;
                }
            }
        }

        if (slotScheduleId && (typeof slotIndex === "number" && slotIndex >= 0)) {
            const slots = this.slots[slotScheduleId];
            const slotForDelete: MScheduleSlot | undefined = this.slots[slotScheduleId][slotIndex];

            if (slotForDelete) {
                const newSlot = new MScheduleSlot({
                    beginAt: slotForDelete.beginAt,
                    endAt: slotForDelete.endAt,
                    scheduleId: slotForDelete.scheduleId,
                    isNotAvailable: false,
                })

                Vue.set(slots, slotIndex, newSlot)

                return slotScheduleId
            }
        }
    }

    private deleteSlots(sheduleIds: string[]) {
        sheduleIds.forEach((scheduleId: string) => {
            delete this.slots[scheduleId];
        })
    }

    setUserProfiles(payload: Map<number, UserProfile>) {
        this.profiles = payload
    }

    addUserProfile(payload: UserProfile) {
        this.profiles.set(payload.userId || 0, payload)
    }
}